module.exports = __webpack_public_path__ + "img/bg8.67e64aa0.jpg";